import React from 'react';
import SkeletonWrapper from './skeleton/SkeletonWrapper';

/**
 * @typedef {object} ReportInfoPanelProps
 * @property {React.ReactNode} [children]
 * @property {string} [panelName]
 * @property {string} [skeletonClassName]
 * @property {boolean} [loading]
 * @property {() => React.ReactNode} [renderChildren]
 */

/**
 * @param {ReportInfoPanelProps} props
 */
export const ReportInfoPanel = props => {
  const { panelName, renderChildren, children, skeletonClassName, loading = false } = props;

  return (
    <SkeletonWrapper
      show={loading}
      skeletonClassName={skeletonClassName}
      renderComponent={() => (
        <div onClick={e => e.stopPropagation()} className={'report-info-panel ' + panelName}>
          {renderChildren ? renderChildren() : children}
        </div>
      )}
    />
  );
};
